import { ErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router";
import { ToastContainer } from "react-toastify";

import { Box, CssBaseline, Typography } from "@mui/material";
import { Alert } from "@mui/material";
import { ReactRouterAppProvider } from "@toolpad/core/react-router";

import "./App.css";
import BcbsMnLogo from "./components/Logo/bcbs-mn-logo.js";
import { theme } from "./contexts/Mui.js";
import { RootContextProvider } from "./contexts/RootContext.js";

function AppContent() {
  // const filteredNavItems: NavigationItem[] = useMemo(() => {
  //   return [
  //     {
  //       segment: "",
  //       title: "Search",
  //       showOnSearch: true,
  //       icon: <SearchIcon />,
  //       hydrateFallbackElement: <FullScreenSpinner type="ellipsis" />,
  //     },
  //     { kind: "divider", showOnSearch: false },
  //     { kind: "header", title: "Dashboard", showOnSearch: false },
  //   ];
  // }, []);

  const BRANDING = {
    logo: (
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <BcbsMnLogo />
        </Box>
        <Typography variant="h4" sx={{ color: "primary.main" }}>
          Provider Reporting & Analytics
        </Typography>
      </>
    ),
    title: "",
    homeUrl: "/",
  };

  return (
    <ReactRouterAppProvider branding={BRANDING} theme={theme} window={window}>
      <RootContextProvider>
        {/* Render route children */}
        <Outlet />
      </RootContextProvider>
    </ReactRouterAppProvider>
  );
}

export default function App() {
  return (
    <ErrorBoundary fallback={<Alert severity="error">An error occurred on the page</Alert>}>
      <CssBaseline />
      <AppContent />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </ErrorBoundary>
  );
}
